import { hhoRpc } from './rpcSender';

export const getNewImage = (image): Promise<any> => {
  return hhoRpc({
    method: 'post',
    headers: {},
    payload: {
      image
    },
    url: 'order_reviews/customize/visual/matting?token=changqing2401'
  });
};

export const getPreviewImage = (url: string): Promise<any> => {
  return hhoRpc({
    method: 'post',
    headers: {},
    payload: {
      url,
      maxSize: 350
    },
    url: 'https://api.7sgood.com/image/preview_image'
  });
};

export const getItemPreviewImage = (image: string, itemId: string, skuId: string): Promise<any> => {
  return hhoRpc({
    method: 'get',
    headers: {},
    payload: {
      image,
      itemId,
      skuId
    },
    url: 'https://api.hhocool.com/order_reviews/design/item/preview'
  });
};
